<template>
  <div >
    <ul class="sidebar-nav lms-nav">
          <template v-if="hasPermission(['buddy_worker'])">
            <!-- manageActiveSection(1) || hasPermission(['buddy_worker']) -->
            <li class="nav-item">
              <a class="nav-link nav-descr text-uppercase d-flex align-items-center">
                <span class="pt-1">Buddy ажилтан</span> <feather type="star" class="ml-2 -mt-2 text-orange-600"></feather>
              </a>
            </li>
            <li class="nav-item" >
              <router-link :to="{ name: 'buddyWorker' }"
                class="nav-link openbook" :class="{ active: $route.name=='buddyWorker' || $route.name=='buddyWorkerDetail' }" >
                Шинэ ажилтан
              </router-link>
            </li>
            <li class="nav-item" >
              <router-link :to="{ name: 'buddyWorkerRead' }"
                class="nav-link book" :class="{ active: $route.name=='buddyWorkerRead' }" >
                Унших материал
              </router-link>
            </li>
            <li class="nav-item" >
              <router-link :to="{ name: 'buddyWorkerRank' }"
                class="nav-link star" :class="{ active: $route.name=='buddyWorkerRank' }" >
                Шилдэг Buddy
              </router-link>
            </li>
          </template>

          <template v-else-if="hasPermission(['buddy_chief'])">
            <!-- manageActiveSection(2) || hasPermission(['buddy_chief']) -->
            <li class="nav-item">
              <a class="nav-link nav-descr text-uppercase d-flex align-items-center">
                <span class="pt-1">Onboarding</span> <feather type="star" class="ml-2 -mt-2 text-orange-600"></feather>
              </a>
            </li>
            <li class="nav-item" >
              <router-link :to="{ name: 'buddyChief' }"
                class="nav-link openbook" :class="{ active: $route.name=='buddyChief' || $route.name=='buddyChiefDetail' }" >
                Ажилтан
              </router-link>
            </li>
            <li class="nav-item" >
              <router-link :to="{ name: 'buddyChiefRead' }"
                class="nav-link book" :class="{ active: $route.name=='buddyChiefRead' }" >
                Унших материал
              </router-link>
            </li>
          </template>

          <!-- <template v-if="manageActiveSection(3)">
            <li class="nav-item">
              <a class="nav-link nav-descr text-uppercase d-flex align-items-center">
                <span class="pt-1">Onboarding хөтөлбөр</span> <feather type="star" class="ml-2 -mt-2 text-orange-600"></feather>
              </a>
            </li>
            <li class="nav-item" >
              <router-link :to="{ name: 'buddyDepartDashboard' }"
                class="nav-link home" :class="{ active: $route.name=='buddyDepartDashboard' }" >
                Дашбоард
              </router-link>
            </li>
            <li class="nav-item" >
              <router-link :to="{ name: 'buddyDepartReport' }"
                class="nav-link book" :class="{ active: $route.name=='buddyDepartReport' }" >
                Тайлан
              </router-link>
            </li>
          </template>  -->

          <template v-else-if="hasPermission(['buddy_participant'])">
            <!-- manageActiveSection(4) || hasPermission(['buddy_participant']) -->
            <li class="nav-item">
              <a class="nav-link nav-descr text-uppercase d-flex align-items-center">
                <span class="pt-1">Шинэ ажилтан</span> <feather type="star" class="ml-2 -mt-2 text-orange-600"></feather>
              </a>
            </li>
            <li class="nav-item" >
              <router-link :to="{ name: 'buddyParticipant' }"
                class="nav-link openbook" :class="{ active: isWelcomeActive() }" >
                Тавтай морил
              </router-link>
            </li>
            <li class="nav-item" >
              <router-link :to="{ name: 'buddyChecklist' }"
                class="nav-link tickdouble" :class="{ active: $route.name == 'buddyChecklist' }" >
                Checklist
              </router-link>
            </li>
            <li class="nav-item" >
              <router-link :to="{ name: 'buddyExam', params: { id: 0 } }"
                class="nav-link star" :class="{ active: $route.name == 'buddyExam' }" >
                Шинэ ажилтны шалгалт
              </router-link>
            </li>
            <li class="nav-item" >
              <router-link :to="{ name: 'buddyFaq', params: { id: 0 } }"
                class="nav-link collection" :class="{ active: $route.name == 'buddyFaq' }" >
                FAQ
              </router-link>
            </li>
          </template>
          <template v-else-if="hasPermission(['lmsbuddyadmin'])">
            <!-- manageActiveSection(5) || hasPermission(['lmsbuddyadmin']) -->
            <li class="nav-item">
              <a class="nav-link nav-descr text-uppercase d-flex align-items-center">
                <span class="pt-1">Onboarding</span> <feather type="star" class="ml-2 -mt-2 text-orange-600"></feather>
              </a>
            </li>
            <li class="nav-item" >
              <router-link :to="{ name: 'buddyAdminDashboard' }"
                class="nav-link home" :class="{ active: $route.name == 'buddyAdminDashboard' || $route.name=='buddyAdminDashboardDetail' || $route.name=='buddyAdminDashboardCalltocare' }" >
                Дашбоард
              </router-link>
            </li>
            <li class="nav-item" >
              <router-link :to="{ name: 'buddyAdminChecklistDashboard' }"
                class="nav-link tickdouble" :class="{ active: isChecklistActive() }" >
                Checklist
              </router-link>
            </li>
            <li class="nav-item" >
              <router-link :to="{ name: 'buddyAdminReport' }"
                class="nav-link magazine" :class="{ active: isReportActive() }" >
                Тайлан
              </router-link>
            </li>
            <li class="nav-item" >
              <router-link :to="{ name: 'buddyAdminBuddy' }"
                class="nav-link collection" :class="{ active: $route.name == 'buddyAdminBuddy' || $route.name == 'buddyAdminBuddyDetail' }" >
                Buddy ажилтан
              </router-link>
            </li>
            <li class="nav-item" >
              <router-link :to="{ name: 'buddyAdminAssign' }"
                class="nav-link user-circle" :class="{ active: $route.name == 'buddyAdminAssign'}" >
                Шинэ ажилтан
              </router-link>
            </li>
            <li class="nav-item" >
              <router-link :to="{ name: 'buddyAdminRead' }"
                class="nav-link openbook" :class="{ active: $route.name == 'buddyAdminRead' }" >
                Унших материал
              </router-link>
            </li>
          </template>
        </ul>
  </div>
</template>

<script>
import { hasOneOf } from "@/libs/tools";
import svgIcon from "@/assets/svg/all.vue";
import vueCustomScrollbar from "vue-custom-scrollbar";

export default {
  components: {
    svgIcon,
    vueCustomScrollbar,
  },
  props: {
    
  },
  data() {
    return {
      myResBaseUrl: "https://res.gosmart.mn/",
    };
  },
  created() {
    this.fetchResBase();
  },
  mounted() {
  },
  methods: {
    fetchResBase() {
      if (
        this.$store.state.app.activeGroup.resBaseUrl != undefined &&
        this.$store.state.app.activeGroup.resBaseUrl != ""
      ) {
        this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
      }
    },
    hasPermission(arr) {
      if (this.$store.state.user.userId == "") return false;
      return hasOneOf(this.$store.state.user.userInfo.access, arr);
    },
    isWelcomeActive(){
      return hasOneOf([this.$route.name], 
        ["buddyParticipant", "buddyCulture", "buddyVoucher", "buddyEvent",
          "buddyQuiz", "buddyQuizFill"
        ]
      );
    },
    isChecklistActive(){
      return hasOneOf([this.$route.name], 
        ["buddyAdminChecklistDashboard", "buddyAdminChecklist1Detail","buddyAdminChecklist2Depart", "buddyAdminChecklist3Employee"]
      );
    },
    isReportActive(){
      return hasOneOf([this.$route.name], 
        ["buddyAdminReport","buddyAdminReportDetail", "buddyAdminReportCheck", "buddyAdminReportDepart"]
      );
    },
    manageActiveSection(mode){
       console.log('mode', mode)
       //# 1 => buddy_worker
       //# 2 => buddy_chief
       //# 3 => 
       //# 4 => buddy_participant
       //# 5 => lmsbuddyadmin

      if(mode==1){
        return hasOneOf([this.$route.name], ["buddyWorker" , "buddyWorkerDetail", "buddyWorkerRead", "buddyWorkerRank"]);
      } else if(mode==2){
        return hasOneOf([this.$route.name], ["buddyChief", "buddyChiefDetail", "buddyChiefRead"]);
      } 
      // else if(mode==3) {
      //   return hasOneOf([this.$route.name], ["buddyDepartDashboard", "buddyDepartReport"]);
      // } 
      else if(mode==4) {
        // console.log('this.$route.name', this.$route.name);
        return !hasOneOf([this.$route.name], ["buddyWorker" , "buddyWorkerDetail", "buddyWorkerRead", "buddyWorkerRank", 
          "buddyChief", "buddyChiefDetail", "buddyChiefRead", "buddyDepartDashboard", "buddyDepartReport",
          "buddyAdminDashboard", "buddyAdminDashboardDetail", "buddyAdminDashboardCalltocare", "buddyAdminBuddy", "buddyAdminBuddyDetail",
          "buddyAdminChecklistDashboard", "buddyAdminChecklist1Detail", "buddyAdminChecklist2Depart", "buddyAdminChecklist3Employee",
          "buddyAdminReport","buddyAdminReportDetail", "buddyAdminReportCheck", "buddyAdminReportDepart",
          "buddyAdminAssign",
          "buddyAdminRead"
        ]);;
      } else if(mode==5){
        // return true;
        return hasOneOf([this.$route.name], ["buddyAdminDashboard", "buddyAdminDashboardDetail", "buddyAdminDashboardCalltocare", "buddyAdminBuddy" ,"buddyAdminBuddyDetail",
        "buddyAdminChecklistDashboard", "buddyAdminChecklist1Detail","buddyAdminChecklist2Depart", "buddyAdminChecklist3Employee",
        "buddyAdminReport","buddyAdminReportDetail", "buddyAdminReportCheck", "buddyAdminReportDepart",
        "buddyAdminAssign",
        "buddyAdminRead"
        ]);;
      }
    },
  },
};
</script>

<style></style>
